import React, { useContext } from "react";
import Context from "../../Context";
export default function CrumbsProvider(props) {
  let cx = useContext(Context);
  cx.breadCrumbsAdd(props.title, props.link);
  return <></>;
}
